import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Card from '../../Components/Card';

import {
  GetDateValue,
} from '../../Util/Properties';

class OrganizationGroupCard extends Component {
  render() {
    const {
      OrganizationGroup,
      style,
      height,
      onCardAction,
      onSelect,
      selected,
      isSearchResults,
    } = this.props;

    let metadata = [];

    metadata.push(["Created", GetDateValue(OrganizationGroup.CreatedOn)]);

    return (
      <Card
        style={style}
        height={height}
        onCardAction={onCardAction}
        onSelect={onSelect}
        selected={selected}
        minHeight={132}
        name={OrganizationGroup.Name}
        metadata={metadata}
        isSearchResults={isSearchResults}
        contentItem={OrganizationGroup}
      />
    );
  }
}

OrganizationGroupCard.propTypes = {
  OrganizationGroup: PropTypes.object.isRequired,
  onCardAction: PropTypes.func.isRequired,
};

export default OrganizationGroupCard;
